import {
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
} from '@ps20-frontend/shop-integration-redux';
import { App, IAnimalValueLabelElement } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { Domaene, DogBreed, Tierrassen } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';

export enum CheckoutTierrassenListRequestActions {
  TIERRASSENLISTE_REQUEST_SUCCESSFUL = 'CHECKOUT_TIERRASSENLISTE_REQUEST_SUCCESSFUL',
  TIERRASSENLISTE_REQUEST_FAILED = 'CHECKOUT_TIERRASSENLISTE_REQUEST_FAILED',
}

export const URL_TIERRASSENLISTE = '/privatschutz/api/tierrassen';

export function* watchTierrassenListRequest(): SagaIterator {
  yield takeEvery(
    GlobalActions.SAVED_STATES_LOADED,
    safeSaga(getTierrassenListSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    CheckoutTierrassenListRequestActions.TIERRASSENLISTE_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* getTierrassenListSaga(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL_TIERRASSENLISTE,
      successEvent: CheckoutTierrassenListRequestActions.TIERRASSENLISTE_REQUEST_SUCCESSFUL,
      errorEvent: CheckoutTierrassenListRequestActions.TIERRASSENLISTE_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction): SagaIterator {
  const tierrassen = successAction.payload as Tierrassen;
  yield put(new GlobalActions().hunderassenListeRetrieved(mapTierrassen(tierrassen.hunderassen)));
  yield put(new GlobalActions().pferderassenListeRetrieved(mapTierrassen(tierrassen.pferderassen)));
  yield put(new GlobalActions().katzenrassenListeRetrieved(mapTierrassen(tierrassen.katzenrassen)));
}

function mapTierrassen(
  tierrassenListe: Array<Domaene | DogBreed>,
): Array<IAnimalValueLabelElement> {
  return (tierrassenListe ?? [])
    .map(elem => {
      const result: IAnimalValueLabelElement = { value: elem.wert, label: elem.text };
      if ('motherBreed' in elem && elem.motherBreed != null) {
        result.motherBreed = {
          value: (elem as DogBreed).motherBreed.wert,
          label: (elem as DogBreed).motherBreed.text,
        };
      }
      return result;
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}
